<template>
  <card :class="stateClass">
    <card-toolbar class="is-upper has-upper-radius is-compact" slot="toolbar" :isMobile="true">
      <div slot="left">
        <b-icon v-if="hasTrend" :icon="trendIcon" custom-size="default"/>
        <span><slot name="label"/></span>
      </div>
      <div slot="right">
        <slot name="label-right"/>
      </div>
    </card-toolbar>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <b-icon :icon="icon" class="is-card-widget-icon" custom-size="mdi-48px"/>
        </div>
        <div class="level-item">
          <div class="card-widget">
            <div class="heading" :class="trendingClass">
              <slot name="heading"/>
              <b-icon v-if="hasTrend" :icon="trendIcon" custom-size="default"/>
            </div>
            <growing-number :value="number" :prefix="numberPrefix" :suffix="numberSuffix" class="title"/>
          </div>
        </div>
      </div>
    </div>

  </card>
</template>

<script>
  import CardToolbar from '@/components/CardToolbar'
  import GrowingNumber from '@/components/GrowingNumber'
  import Card from '@/components/Card'
  export default {
    name: "CardWidget",
    components: {
      CardToolbar,
      GrowingNumber,
      Card
    },
    props: {
      isTrending: {
        type: Boolean,
        default: null,
      },
      icon: {
        type: String,
        default: null,
      },
      state: {
        type: String,
        default: null,
      },
      numberSuffix: {
        type: String,
        default: null,
      },
      numberPrefix: {
        type: String,
        default: null,
      },
      number: {
        type: Number,
        default: 0
      }
    },
    computed: {
      hasTrend() {
        return this.isTrending !== null;
      },
      trendIcon() {
        if (this.isTrending)
          return 'arrow-up-bold'

        return 'arrow-down-bold'
      },
      trendingClass() {
        if (this.hasTrend) {
          if (this.isTrending)
            return 'is-trending-up';

          return 'is-trending-down';
        }

        return null
      },
      stateClass() {
        if (this.state)
          return 'is-widget-state-' + this.state;

        return null
      }
    }
  }
</script>

<style scoped>
.title {
	font-size: 27px !important;
}
</style>
